/**
 * The supplier portal's emailed link carries its token in the URL fragment (`/po/PO-K20417#<token>`, EA §5.11), so
 * it is never sent to a server, written to an access log or leaked in a Referer. The page reads it from the
 * fragment and sends it with each request.
 */

/** The link token in a location's fragment (`#abc` → `abc`), or null when there is none. */
export function linkTokenFromFragment(hash: string): string | null {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!raw) return null;
  try {
    const token = decodeURIComponent(raw).trim();
    return token || null;
  } catch {
    // A malformed escape is not a token; the page treats it as no link.
    return null;
  }
}
